/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-14 14:34:29
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-14 16:43:21
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SortableTree/Theme/index.js
 */
import nodeContentRenderer from './node-content-renderer';
import treeNodeRenderer from './tree-node-renderer';

module.exports = {
  nodeContentRenderer,
  treeNodeRenderer,
  scaffoldBlockPxWidth: 24,
};
